<div class="card-title-block-non-sticky" *ngIf="isDocumentNotFound && !isLoading">
	<copo-back-button></copo-back-button>
	<span class="card-title-label" translate>document-card.data-not-found</span>
</div>
<div class="sidenav-content" [copoScroller]="{restoreAfterViewInit: false}" #scroller="copoScroller" *ngIf="!(isDocumentNotFound && !isLoading)">
	<ng-container *ngIf="!isOffline; else offline">
		<ng-container *ngIf="!isLoading else loading">
			<ng-container *ngIf="dispatchAdviceData && dispatchAdviceDisplayed">
				<div class="card-title-block-non-sticky">
					<copo-back-button></copo-back-button>
					<span class="card-title-label" translate>shipment.dispatch-advice</span>
					<span class="card-title-label card-title-name-label">{{dispatchAdviceData.name ?
						dispatchAdviceData.name :
						UNDERSCORE}}</span>
					<a mat-icon-button class="order-card-document-link-block"
						[href]="getDocumentURL(dispatchAdviceData.id,dispatchAdviceData.name) | copoSafeUrl"
						target="_blank" type="application/pdf" (click)="scroller.saveState()" [title]="'quapp.action.view' | translate">
						<mat-icon color="accent" svgIcon="md:eye"></mat-icon>
					</a>
					<a mat-icon-button class="order-card-document-link-block"
						[href]="getDownloadDocumentUrl(dispatchAdviceData.id,dispatchAdviceData.name) | copoSafeUrl"
						target="_blank" type="application/pdf" (click)="scroller.saveState(); trackDownload(dispatchAdviceData.id)" [title]="'sb.Download' | translate">
						<mat-icon color="accent" svgIcon="md:download"></mat-icon>
					</a>
				</div>
				<div class="copo-container footer-margin" copoAfterViewInit (afterviewinit)="scroller.restoreState()">
					<div class="grid-6">
						<div class="grid-column-one-full">
							<mat-expansion-panel [expanded]="true" class="card-info-block">
								<mat-expansion-panel-header>
									<mat-panel-title class="card-content-title">
										<span translate>commercial-documents.general-information</span>
									</mat-panel-title>
								</mat-expansion-panel-header>
								<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<mat-icon class="row-icon" svgIcon="at_consignment"></mat-icon>
										<span class="card-content-value">{{dispatchAdviceData.millDescription ? dispatchAdviceData.millDescription : UNDERSCORE}}</span>
									</div>
									<div class="card-content-info">
										<mat-icon class="row-icon" svgIcon="train"></mat-icon>
									<span class="card-content-value">{{dispatchAdviceData.transportModeDescription ? dispatchAdviceData.transportModeDescription : UNDERSCORE}}
									</span>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>shipment.dispatch-advice-date</div>
										<div class="card-content-value">{{(dispatchAdviceData.dispatchAdviceDate ? dispatchAdviceData.dispatchAdviceDate : UNDERSCORE) | copoDate:'date'}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>batch.card.customer</div>
										<div class="card-content-value">{{dispatchAdviceData.soldtoName? dispatchAdviceData.soldtoName : UNDERSCORE}}</div>
									</div>

								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>batch.shipto</div>
										<div class="card-content-value">{{dispatchAdviceData.shiptoName ? dispatchAdviceData.shiptoName : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.payer</div>
										<div class="card-content-value">{{dispatchAdviceData.payerName ?dispatchAdviceData.payerName : UNDERSCORE}}</div>
									</div>
								</div>
							</div>
							</mat-expansion-panel>
						</div>
					</div>
					<div class="grid-column-one-full document-card-batch-order-details card-title-name-label" translate>commercial-documents.batches-details</div>
					<div class="grid-column-one-full document-card-orders-details-headers">
						<span translate>order.orders <span>(&nbsp;{{orderNumbers.length}}&nbsp;)</span></span>
						<button type="button" translate class="tag-order-number tag-order-number-clickable batch-details-margin-left"
							[ngClass]="{'active-tag-order-number active-tag-order-number-clickable': allBatchesDisplayed }"
							(click)="allBatchesDisplayed = true; displayAllBatches()">datacenter.all
						</button>
						<span *ngFor="let orderNumber of orderNumbers" class="batch-details-margin-left">
							<button type="button" class="tag-order-number tag-order-number-clickable"
								[ngClass]="{'active-tag-order-number active-tag-order-number-clickable': !allBatchesDisplayed && orderNumber.isSelected}"
								(click)="filterBatch(orderNumber)">
								{{orderNumber.key}}</button>
						</span>
					</div>
					<div *ngFor="let dispatchAdviceDetail of dispatchAdviceData.documentLines">
						<div *ngIf="dispatchAdviceDetail.isSelected" class="document-card-margin-bottom">
							<mat-expansion-panel [expanded]="true" class="card-info-block">
								<mat-expansion-panel-header>
									<mat-panel-title>
										<div class="batch-details-card-first-row">
											<span class="card-sub-title" translate>shipment.filter.batch-number</span>
											<span class="card-sub-title">{{dispatchAdviceDetail.batchNumber ? dispatchAdviceDetail.batchNumber : UNDERSCORE}}</span>
											<span class="tag-order-number tag-order-number-not-active">{{getOrderName(dispatchAdviceDetail, 'order') }}</span>
										</div>
									</mat-panel-title>
								</mat-expansion-panel-header>
								<mat-divider class="margin-expansion-panel"></mat-divider>
							
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.customer-order-number</div>
										<a class="card-content-value"
											[routerLink]="['/order-tracking/order/card', dispatchAdviceDetail.supplierOrderReference, dispatchAdviceDetail.supplierOrderReferenceItem]">
											{{ getOrderName(dispatchAdviceDetail, 'order') }}
										</a>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.supplier-order-number</div>
										<a class="card-content-value"
											[routerLink]="['/order-tracking/order/card', dispatchAdviceDetail.supplierOrderReference, dispatchAdviceDetail.supplierOrderReferenceItem]">
											{{ dispatchAdviceDetail.supplierOrderReference }}/{{ dispatchAdviceDetail.supplierOrderReferenceItem }}
										</a>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents-da.heat</div>
										<div class="card-content-value">{{dispatchAdviceDetail.heatNumber ? dispatchAdviceDetail.heatNumber : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.transport-reference</div>
										<div class="card-content-value">{{dispatchAdviceDetail.transportReference ? dispatchAdviceDetail.transportReference : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>batch.card.weight</div>
										<div class="card-content-value">{{getQtyBatch(dispatchAdviceDetail.batchNumber, 'WEIGHT')}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>datacenter-filter.product-description</div>
										<div class="card-content-value">{{dispatchAdviceDetail.productDescription ? dispatchAdviceDetail.productDescription : UNDERSCORE}}</div>
									</div>

								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents-da.serial</div>
										<div class="card-content-value">{{dispatchAdviceDetail.packageSerialNumber ? dispatchAdviceDetail.packageSerialNumber : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.customer-article-reference</div>
										<div class="card-content-value">{{dispatchAdviceDetail.customerArticleReference ? dispatchAdviceDetail.customerArticleReference : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>batch.length</div>
										<div class="card-content-value">{{getQtyBatch(dispatchAdviceDetail.batchNumber, 'LENGTH')}}</div>
									</div>

								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.mill-order-number</div>
										<div class="card-content-value">{{getOrderName(dispatchAdviceDetail, 'millOrder') }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents-da.supplier-article-reference</div>
										<div class="card-content-value">{{dispatchAdviceDetail.supplierArticleReference ? dispatchAdviceDetail.supplierArticleReference : UNDERSCORE}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents-da.enduser</div>
										<div class="card-content-value">{{dispatchAdviceDetail.enduserName ? dispatchAdviceDetail.enduserName : UNDERSCORE}}</div>
									</div>
								</div>
							</div>
							</mat-expansion-panel>
						</div>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>
	<ng-template #offline>
		<copo-offline></copo-offline>
	</ng-template>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>